<template>

	<EmergencyWindow ref='_window'
		:chain='_is_submenu ? "popup" : "popup:reset"'
		:options='{ autofocus: "none", type: "menu" }'
		:actions='{ header: [], tray: [] }'
		:class='[ { centered }, { biggerItems } ]'>
		<slot />
		<ul class='items'>
			<li v-for='item in _items'>

				<router-link v-if='item.link'
					:to='item.link'>
					<span class='icon' v-html='item?.icon' />
					<span class='label'>{{ txs( item?.label ) }}</span>
					<span class='submenu-icon'></span>
				</router-link>

				<a v-else
					@click='_Click( $event, item )'>
					<span class='icon' v-html='item?.icon' />
					<span class='label'>{{ txs( item?.label ) }}</span>
					<span class='submenu-icon'><i v-if='item?.submenu' class='fa fa-chevron-right' /></span>
				</a>

			</li>
		</ul>
	</EmergencyWindow>

</template>

<script setup>

	import { computed, ref } from 'vue';
	import { useRouter } from 'vue-router/dist/vue-router';
	import { txs } from '@/modules/i18n';

	import EmergencyWindow from '@/components/emergency/EmergencyWindow.vue';

	import * as Yue from '@/modules/yue-next';
	import * as User from '@/modules/user';

	//

	const _window = ref();

	const _props = defineProps
	( {
		items: Array,
		anchorX:
		{
			type: String,
			default ()
			{
				return 'left';
			}
		},
		anchorY:
		{
			type: String,
			default ()
			{
				return 'bottom';
			}
		},
		directionX:
		{
			type: String,
			default ()
			{
				return 'right';
			}
		},
		directionY:
		{
			type: String,
			default ()
			{
				return 'bottom';
			}
		},
		deltaX:
		{
			type: String,
			default ()
			{
				return '';
			}
		},
		deltaY:
		{
			type: String,
			default ()
			{
				return '';
			}
		},
		allowCollision: Boolean,
		centered: Boolean,
		biggerItems: Boolean
	} );

	const router = useRouter();

	const _is_submenu = ref( false );

	defineExpose( { Open, Close } );

	const _items = computed( () =>
	{
		return _props.items.filter( Is_visible );
	} );

	//


	async function Open ( anchor, as_submenu = false )
	{
		_is_submenu.value = as_submenu;

		await _window.value.Open();

		let window = _window.value.Get_element();

		let pos = as_submenu
			? Yue.Get_anchored_position( window,
				{ element: anchor, x: _props.anchorX, y: _props.anchorY, delta_x: '0.25rem', delta_y: '-0.25rem', flip_priority: 'horizontal' },
				{ x: _props.directionX, y: _props.directionY },
				_props.allowCollision )
			: Yue.Get_anchored_position( window,
				{ element: anchor, x: _props.anchorX, y: _props.anchorY, delta_x: _props.deltaX, delta_y: _props.deltaY, flip_priority: 'vertical' },
				{ x: _props.directionX, y: _props.directionY },
				_props.allowCollision );

		window.style.left = pos.left;
		window.style.top = pos.top;
	}


	function Close ()
	{
		_window.value.Close();
	}


	function Is_visible ( item )
	{
		if ( !( 'visibility' in item ) )
			return true;

		let result = true;

		if ( 'user' in item.visibility )
			result = result && ( item.visibility.user == User.Is_user() );

		if ( 'admin' in item.visibility )
			result = result && ( item.visibility.admin == User.Is_admin() );

		if ( 'page' in item.visibility )
			result = router.currentRoute.value.name == item.visibility.page;

		return result;
	}


	function _Click ( event, item )
	{
		if ( item?.submenu )
			item.submenu.Open( event.currentTarget, true );
		else if ( item?.action )
			item.action();
	}

</script>

<style scoped>

	.items
	{
		list-style: none;
		padding: 0;
		margin: 0;
	}

	.items li + li
	{
		margin-top: 0.25rem;
	}

	.items li a
	{
		display: flex;
		align-items: center;
		padding: 0 0.25rem;
		cursor: pointer;
		color: var(--wf-text);
		transition: background 0.3s, color 0.3s;
		border-radius: 0.25rem;
		min-width: 8rem;
		white-space: nowrap;
		line-height: 2rem;
	}
	.items li a:hover
	{
		text-decoration: none;
		background: rgba(0,0,0,0.1);
	}

	.items li a .icon,
	.items li a .submenu-icon
	{
		flex: 0 0 1.5rem;
		margin-right: 0.25rem;
		font-size: 0.9rem;
		text-align: center;
		display: block;
		width: 1.5rem;
	}
	.items li a .label
	{
		flex: 1 0 auto;
	}
	.items li a .submenu-icon
	{
		text-align: right;
		font-size: 0.8rem;
		color: var(--wf-accent-lighter);
	}


	.biggerItems .items li + li
	{
		margin-top: 0.5rem;
	}
	.biggerItems .items li a
	{
		font-size: 1.05rem;
		padding: 0.25rem 1rem;
	}


	.centered .items li a
	{
		justify-content: center;
	}

	.centered .items li a .label
	{
		flex: 0 0 auto;
		padding-right: 0.25rem;
	}

	.centered .items li a .icon:empty,
	.centered .items li a .submenu-icon:empty
	{
		display: none;
	}

</style>